export * from './getTVARate'

import { TFunction } from 'i18next'

import {
  InternalInventoryDocumentState,
  InventoryDocumentState,
  InventoryStatus
} from 'src/api/requests'

export const getStatus = (
  t: TFunction,
  status: InventoryDocumentState | InternalInventoryDocumentState
) => {
  const statusMap = {
    [InventoryDocumentState.ACCEPTED]: {
      color: 'green',
      text: t('stock_applications.accepted')
    },
    [InventoryDocumentState.NEW]: {
      color: 'gold',
      text: t('stock_applications.new')
    },
    [InventoryDocumentState.WAITING]: {
      color: 'gold',
      text: t('stock_applications.waiting')
    },
    [InventoryDocumentState.CONFIRMED]: {
      color: 'green',
      text: t('stock_applications.confirmed')
    },
    [InventoryDocumentState.REJECTED]: {
      color: 'red',
      text: t('stock_applications.rejected')
    },
    [InventoryDocumentState.APPROVED]: {
      color: 'green',
      text: t('stock_applications.approved')
    },
    [InventoryDocumentState.RECEIVED]: {
      color: 'green',
      text: t('stock_applications.received')
    },
    [InventoryDocumentState.MODIFIED_AND_ACCEPTED]: {
      color: 'green',
      text: t('stock_applications.modifiedAndAccepted')
    },
    [InventoryDocumentState.CANCELED]: {
      color: 'red',
      text: t('stock_applications.canceled')
    }
  }

  return {
    color: statusMap[status]?.color ?? 'defaultColor',
    text: statusMap[status]?.text ?? t('stock_applications.unknown')
  }
}

export const getEntryStatus = (
  t: TFunction,
  status?: InventoryDocumentState | InternalInventoryDocumentState
) => {
  const statusMap = {
    [InventoryDocumentState.ACCEPTED]: {
      color: 'green',
      text: t('stock_applications.accepted')
    },
    [InventoryDocumentState.NEW]: {
      color: 'gold',
      text: t('stock_applications.new')
    },
    [InventoryDocumentState.WAITING]: {
      color: 'gold',
      text: t('stock_applications.waiting')
    },
    [InventoryDocumentState.REJECTED]: {
      color: 'red',
      text: t('stock_applications.rejected')
    },
    [InventoryDocumentState.CONFIRMED]: {
      color: 'green',
      text: t('stock_applications.confirmed')
    },
    [InventoryDocumentState.APPROVED]: {
      color: 'blue',
      text: t('stock_applications.approved')
    },
    [InventoryDocumentState.RECEIVED]: {
      color: 'green',
      text: t('stock_applications.received')
    },
    [InventoryDocumentState.MODIFIED_AND_ACCEPTED]: {
      color: 'green',
      text: t('stock_applications.modifiedAndAccepted')
    },
    [InventoryDocumentState.CANCELED]: {
      color: 'red',
      text: t('stock_applications.canceled')
    }
  }

  return {
    color: status ? statusMap[status]?.color : 'defaultColor',
    text: status ? statusMap[status]?.text : t('stock_applications.unknown')
  }
}

export const getSettlementStatus = (
  t: TFunction,
  status?: InventoryDocumentState | InternalInventoryDocumentState
) => {
  const statusMap = {
    [InventoryDocumentState.ACCEPTED]: {
      color: 'green',
      text: t('stock_applications.accepted')
    },
    [InventoryDocumentState.NEW]: {
      color: 'gold',
      text: t('stock_applications.new')
    },
    [InventoryDocumentState.WAITING]: {
      color: 'gold',
      text: t('stock_applications.waiting')
    },
    [InventoryDocumentState.REJECTED]: {
      color: 'red',
      text: t('stock_applications.rejected')
    },
    [InventoryDocumentState.CONFIRMED]: {
      color: 'green',
      text: t('stock_applications.confirmed')
    },
    [InventoryDocumentState.APPROVED]: {
      color: 'blue',
      text: t('stock_applications.approved')
    },
    [InventoryDocumentState.RECEIVED]: {
      color: 'green',
      text: t('stock_applications.received')
    },
    [InventoryDocumentState.MODIFIED_AND_ACCEPTED]: {
      color: 'green',
      text: t('stock_applications.modifiedAndAccepted')
    },
    [InventoryDocumentState.CANCELED]: {
      color: 'green',
      text: t('stock_applications.recovered')
    }
  }

  return {
    color: status ? statusMap[status]?.color : 'defaultColor',
    text: status ? statusMap[status]?.text : t('stock_applications.unknown')
  }
}

export const getCostPerUnitTva = (unitPrice: number, tvaRate: string) => {
  if (!unitPrice || !tvaRate) return '-'

  const numTvaRate = parseFloat(tvaRate.replace('%', ''))

  return Math.round(unitPrice * (1 + numTvaRate / 100) * 100) / 100
}

export const getTotalTvaPrice = (
  quantity: number,
  unitPrice: number,
  tvaRate: string
) => {
  if (!unitPrice || !tvaRate || !quantity) return '-'

  const numTvaRate = parseFloat(tvaRate.replace('%', ''))

  return (
    Math.round(quantity * unitPrice * (1 + numTvaRate / 100) * 10000) / 10000
  )
}

export const getStockValidStatus = (
  t: TFunction,
  status?: InventoryStatus | null
) => {
  if (!status)
    return {
      color: '',
      text: '-'
    }

  const statusMap = {
    [InventoryStatus.VALID]: {
      color: 'green',
      text: t('stock.status_valid')
    },
    [InventoryStatus.EXPIRED]: {
      color: 'red',
      text: t('stock.status_expired')
    },
    [InventoryStatus.EXPIRE_IN_AWHILE]: {
      color: 'gold',
      text: t('stock.status_expireInAWhile')
    }
  }

  return {
    color: statusMap[status]?.color ?? 'defaultColor',
    text: statusMap[status]?.text ?? t('stock_applications.unknown')
  }
}

export const fixedDecimal = (num: number, digit: number) => {
  if (typeof num !== 'number') return

  return parseFloat(num.toFixed(digit))
}
